/**
 * CargaResponsavelCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaResponsavel} from '@/model/resource/CargaResponsavel'

/* TODO: review generated class */
@HttpExclude()
export class CargaResponsavelCollection extends PageCollection<
  CargaResponsavel
> {
  constructor() {
    super(CargaResponsavel)
  }

  queryAsPage() {
    return this.listCargaResponsavel()
  }

  async listCargaResponsavel() {
    return await Request.get(`/admin/carga-responsavel`, {params: this.params})
      .name('listCargaResponsavel')
      .as(this)
      .getResponse()
  }

  async listCsvCargaResponsavel() {
    return await Request.get(`/admin/carga-responsavel/csv`, {
      params: this.params,
    })
      .name('listCsvCargaResponsavel')
      .as(this)
      .getResponse()
  }
}
